import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Status(): ReactElement {
  return (
    <PageShell
      title="System-Status"
      intro="Aktuelle Verfügbarkeit der Saldify-Dienste."
    >
      <PageSection title="Aktueller Status">
        <div className="flex items-center gap-3 rounded-xl bg-success-50 px-4 py-3 ring-1 ring-success-100">
          <span className="w-2.5 h-2.5 rounded-full bg-success-500" />
          <span className="font-medium text-secondary-900">
            Alle Systeme betriebsbereit
          </span>
        </div>
      </PageSection>

      <PageSection title="Störungen melden">
        <p>
          Sollte Ihnen eine Störung auffallen, informieren Sie uns bitte unter{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          . Geplante Wartungsarbeiten kündigen wir nach Möglichkeit vorab an.
        </p>
      </PageSection>
    </PageShell>
  );
}
